/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.review-highlights__swiper')

  if (!sliders.length) return

  sliders.forEach(function (slider) {
    const section = slider.closest('section')
    if (!section) return

    const sectionId = section.id

    const swiperInstance = new Swiper(slider, {
      spaceBetween: 12,
      slidesPerView: 1.4,
      centeredSlides: true,
      loop: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous review',
        nextSlideMessage: 'Next review'
      },
      pagination: {
        el: '#' + sectionId + ' .review-highlights__pagination',
        clickable: true
      },
      navigation: {
        nextEl: '#' + sectionId + ' .review-highlights__nav-btn--next',
        prevEl: '#' + sectionId + ' .review-highlights__nav-btn--prev'
      },
      breakpoints: {
        750: {
          slidesPerView: 'auto',
          spaceBetween: 20
        },
        990: {
          slidesPerView: 3.25,
          centeredSlides: true,
          spaceBetween: 24
        },
        1280: {
          slidesPerView: 4,
          centeredSlides: true,
          spaceBetween: 24
        },
        1800: {
          slidesPerView: 5.25,
          centeredSlides: true,
          spaceBetween: 24
        }
      }
    })

    // Store reference for potential cleanup
    slider.swiperInstance = swiperInstance
  })
})
